import i18n from "config/i18next";

i18n.addResources("es", "presettlements", {
  presettlementsTitle: "Preliquidaciones",
  presettlement: "preliquidación",
  presettlements: "preliquidaciones",
  sendToAccountingTitle: "Enviá las preliquidaciones a contabilidad",
  sendToAccountingMessage: "¿Deseás enviar {{quantity}} a contabilidad?",
  send: "Sí, enviar",
  sendToAccounting: "Enviar a contabilidad",
  approveInvoices: "Aprobar facturas",
  noInvoicesTitle: "No hay facturas",
  noInvoicesMessage: "Esperá a que hayan más facturas en aprobación",
  concurrencyTitle: "Error en la modificación",
  concurrencyMessage:
    "La preliquidación ya está siendo modificada. Intentalo nuevamente en unos minutos",
  successSendAccountingTitle: "Envío exitoso",
  successSendAccountingBody:
    "Las preliquidaciones fueron enviadas a contabilidad correctamente",
  successSendAccountingBodySingular:
    "La preliquidación fue enviada a contabilidad correctamente",
});
